import { createContext, useContext, useState } from 'react';
import { stepOrder } from '../utils';
import { PaymentOptionsFlowStep } from '../utils';
import { usePhoneMockupLayoutContext } from '@frontend/ui-library';

export const usePaymentOptionsFlow = () => {
  const [step, setStep] = useState<PaymentOptionsFlowStep>(
    PaymentOptionsFlowStep.MethodSelection
  );

  const { animationDirection, setAnimationDirection } =
    usePhoneMockupLayoutContext();

  const goToStep = (newStep: PaymentOptionsFlowStep) => {
    const isGoingForward = stepOrder.indexOf(newStep) > stepOrder.indexOf(step);

    setStep(newStep);
    setAnimationDirection(isGoingForward ? 'forwards' : 'backwards');
  };

  const goBack = () => {
    const currentIndex = stepOrder.indexOf(step);

    if (currentIndex > 0) {
      setAnimationDirection('backwards');
      setStep(stepOrder[currentIndex - 1]);
    }
  };

  const canGoBack = stepOrder.indexOf(step) > 0;

  return {
    step,
    animationDirection,
    canGoBack,
    goToStep,
    goBack,
  };
};

export const PaymentOptionsFlowContext = createContext<
  ReturnType<typeof usePaymentOptionsFlow>
>({} as ReturnType<typeof usePaymentOptionsFlow>);

export const usePaymentOptionsFlowContext = () => {
  const context = useContext(PaymentOptionsFlowContext);
  if (!context) {
    throw new Error(
      'usePaymentOptionsFlowContext must be used within a PaymentOptionsFlowProvider'
    );
  }
  return context;
};
